module.exports = __webpack_public_path__ + "img/user_profile_4.963607ac.png";